import { useState } from 'react';
import { useSendCampaignInvite } from 'api/admin/hooks';
import { Logo } from 'assets/landing';
import toast from 'react-hot-toast';
import { AdminLayout } from 'layout/AdminLayout';
import { downloadBase64Image } from 'utils';
import {
	CAMPAIGN_ID,
	IS_GUEST,
	QRStyle,
	RESTAURANT_ID,
	USER_ID
} from 'utils/constants';
import Styles from './admin.module.scss';

export const AdminScreen = () => {
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [inviteResponse, setInviteResponse] = useState({
		qrCode: '',
		name: ''
	});

	const { mutate: sendInvite } = useSendCampaignInvite({
		onSuccess: (data) => {
			toast.success(`Invite sent to ${firstName} ${lastName}`);

			setInviteResponse({
				qrCode: data.campaign_invite.qr_code,
				name: `${data.user.first_name} ${data.user.last_name}`
			});

			setFirstName('');
			setLastName('');
		},
		onError: (error) => {
			toast.error(error?.response?.data?.message);
		},
	});

	const handleSendInvite = (e) => {
		e.preventDefault();

		sendInvite({
			restaurantID: RESTAURANT_ID,
			campaignID: CAMPAIGN_ID,
			userID: USER_ID,
			firstName,
			lastName,
			isGuest: IS_GUEST,
			qrCodeStyle: QRStyle
		});
	};

	const openQrCodeInNewTab = (dataUrl) => {
		const newTab = window.open();

		newTab.document.write(`
    <html>
      <head>
        <title>QR Code</title>
        <style>
          body {
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100vh;
            background: ${QRStyle === 'Light' ? '#000' : '#fff'};
          }
          img {
            max-width: 90%;
            max-height: 90%;
          }
        </style>
      </head>
      <body>
        <img src="${dataUrl}" alt="QR Code" />
      </body>
    </html>
  `);
	};

	return (
		<AdminLayout>
			<div className={Styles.container}>
				<img width={200} src={Logo} alt='' />
				<h2 className='mt-5'>Send Campaign Invites</h2>
				<form onSubmit={handleSendInvite} className={Styles.form}>
					<div className='d-flex flex-column gap-2 w-100'>
						<label className={Styles.inputLabel} htmlFor='firstName'>
							First Name
						</label>
						<input
							id='firstName'
							value={firstName}
							onChange={(e) => setFirstName(e.target.value)}
							className={Styles.input}
							placeholder='Enter First Name...'
						/>
					</div>

					<div className='d-flex flex-column gap-2 w-100'>
						<label className={Styles.inputLabel} htmlFor='lastName'>
							Last Name
						</label>
						<input
							id='lastName'
							value={lastName}
							onChange={(e) => setLastName(e.target.value)}
							className={Styles.input}
							placeholder='Enter Last Name...'
						/>
					</div>

					<button
						type='submit'
						disabled={!firstName || !lastName}
						className={Styles.submitButton}
					>
						Send Invite
					</button>
				</form>
				<div className={Styles.qrCodeContainer}>
					{inviteResponse.qrCode
						&& <div className='d-flex flex-column align-items-center'>
							<p className='mb-0'>QR Code for <strong>{inviteResponse.name}'s</strong> invite</p>
							<img className={`${Styles.qrCode} ${QRStyle === 'Dark' ? Styles.dark : ''}`} src={inviteResponse.qrCode} alt='qr-code' />
							<button
								className={Styles.downloadButton}
								onClick={() => {
									openQrCodeInNewTab(inviteResponse.qrCode);
									downloadBase64Image(inviteResponse.qrCode, `${inviteResponse.name}-qr-code`);

									setInviteResponse({
										qrCode: '',
										name: ''
									});
								}}
							>
								Download Qr
							</button>
						</div>
					}
				</div>
			</div>
		</AdminLayout>
	);
};
